import moment from "moment";
import { Period } from "../../../../common/models/period";
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class ChangeLeveransplanPeriodCommand extends BasicCommand<ChangeLeveransplanPeriodCommand> {
    readonly kontraktGuid: string;
    readonly periodFrom: string;
    readonly periodTom: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ChangeLeveransplanPeriodCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "LeveransplanPeriod";

    get primaryKey(): IPrimaryKey<ChangeLeveransplanPeriodCommand> {
        return {
            kontraktGuid: this.kontraktGuid,
            periodFrom: this.periodFrom,
            periodTom: this.periodTom
        };
    }

    constructor(kontraktGuid: string,  period: Period) {
        super(ChangeLeveransplanPeriodCommand.$type, ChangeLeveransplanPeriodCommand.$groupKey, CommandType.Replace);
        this.kontraktGuid = kontraktGuid;
        this.periodFrom = moment(period.periodFrom).format("YYYY-MM-DD");
        this.periodTom = moment(period.periodTom).format("YYYY-MM-DD");
    }
}
